export const CREDIT_TYPE_CONFIG = {
    FREE_TEST: {
        label: 'Free Test Credits',
        color: '#C2410C',
        priority: 1,
    },
    TRIAL: {
        label: 'Trial Credits',
        color: '#EA580C',
        priority: 1,
    },
    SUBSCRIPTION: {
        label: 'Monthly Credits',
        color: '#F97316',
        priority: 2,
    },
    TOP_UP: {
        label: 'Top-up Credits',
        color: '#FB923C',
        priority: 3,
    },
    BONUS: {
        label: 'Bonus Credits',
        color: '#FDBA74',
        priority: 4,
    },
    PROMOTIONAL: {
        label: 'Promotional Credits',
        color: '#FED7AA',
        priority: 5,
    },
} as const

export type CreditType = keyof typeof CREDIT_TYPE_CONFIG

export function getCreditTypeConfig(type: CreditType) {
    return (
        CREDIT_TYPE_CONFIG[type] || {
            label: 'Unknown Credits',
            color: '#6B7280',
            priority: 999,
        }
    )
}
